import { FC } from 'react';
import { isNotEmpty, replaceEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';
import V2Tag from '@/common/components/Data/V2Tag';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

/**
 * 统计数据块
 * @description
 * @demo
 */
const Component:FC<{
  value?: any;
  unit?: string;
  label: string;
  tag?: string;
  className?: string,
  help?: string,
}> = ({ value, unit, label, tag, className, help }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={cs(styles.statisticsItem, className)}>
    <div className={styles.valueWrapper}>
      <span className={cs(styles.value, 'value')}>{replaceEmpty(value as any)}</span>
      {isNotEmpty(value) && !!unit && <span className={styles.unit}>{unit}</span>}
      {
        help && (
          <Tooltip
            title={help}
            placement='bottom'
            color='#fff'
            overlayInnerStyle={{
              width: '240px',
              boxSizing: 'border-box',
              borderRadius: '4px',
              padding: '10px',
              color: 'rgba(0, 0, 0, 0.85)',
              fontSize: '12px'
            }}
          >
            <>
              <QuestionCircleOutlined className='fs-12 c-666 ml-2'/>
            </>
          </Tooltip>
        )
      }
    </div>
    <div className={styles.labelWrapper}>
      <span className={cs(styles.label, 'label')}>{label}</span>
      {!!tag && <V2Tag color='orange'>{tag}</V2Tag>}
    </div>
  </div>);
};

export default Component;
